// pages/messages/CompanyConversationsList.js
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'
import { useGlobal } from '../../context/GlobalContext'

function CompanyConversationsList() {
  const { showLoading, hideLoading, showMessage } = useGlobal()
  const [conversations, setConversations] = useState([])

  useEffect(() => {
    loadConversations()
  }, [])

  async function loadConversations() {
    try {
      showLoading()
      const res = await api.get('/company-messages/conversations')
      setConversations(res.data.conversations)
      hideLoading()
    } catch (err) {
      hideLoading()
      showMessage(err.response?.data?.error || 'Error loading conversations', 'error')
    }
  }

  return (
    <div>
      <h2>Conversations</h2>
      {conversations.map(conv => (
        <div key={conv._id}>
          <Link to={`/job-messages/${conv._id}`}>
            {conv.jobTitle ? conv.jobTitle : conv._id}
          </Link>
        </div>
      ))}
    </div>
  )
}

export default CompanyConversationsList